import React from 'react';
import './filter.scss';

const FilterReviews = ({fetchReviews, type, lastStar, pathFinderConfig}) => {

    const gaEvents = ' data-gtm-category=gig-page-old data-gtm-action=click ';

    const handleFetchReviews = (e) => {
        fetchReviews(e, type, lastStar, pathFinderConfig);
    };

    return (
        <div className="filter-dd rf">
            <select onChange={handleFetchReviews}>
                <option className="js-gtm-event-auto" value="all" data-gtm-action={gaEvents} data-gtm-label="reviews-most-recent" data-reviews-type="all" rel="noindex, nofollow">{i18n.t('reviews.gigs._inner_gig.drop_most_recent')}</option>
                <option className="js-gtm-event-auto" value="positive" data-gtm-action={gaEvents} data-gtm-label="reviews-positive" data-reviews-type="positive" rel="noindex, nofollow">{i18n.t('reviews.gigs._inner_gig.drop_positive')}</option>
                <option className="js-gtm-event-auto" value="negative" data-gtm-action={gaEvents} data-gtm-label="reviews-negatve" data-reviews-type="negative" rel="noindex, nofollow">{i18n.t('reviews.gigs._inner_gig.drop_negative')}</option>
            </select>
        </div>
    );
};

export default FilterReviews;



// WEBPACK FOOTER //
// ./src/reviews/filter/Filter.js